import korean from './ko-kr';
import english from './en-us';
import chinese from './zh-cn';
import vietnamese from './vi-vn';
import taiwanese from './zh-tw';
import japanese from './ja-jp';

const texts = {
  ...korean, 
  ...english, 
  ...chinese, 
  ...vietnamese,
  ...taiwanese,
  ...japanese,
}

export default texts;